import React from 'react'
import { bool, object, } from 'prop-types'
import { ReactComponent as Info } from '../../../../assets/icons/help-circle.svg'
import styled from 'styled-components'

const SaibaMaisWrapper = styled.div`
  padding: 8px 0 18px 35px;
  display: flex;
  align-items: center;
  gap: 22px;
  text-decoration: underline;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;

  color: ${props => ( props.isCuradoria ? '#009BBF' : '#EB8100' )};
  svg path {
    stroke: ${props => ( props.isCuradoria ? '#009BBF' : '#EB8100' )};
  }

  @media (max-width: 520px) {
    padding: 8px 0 18px 25px;
  }
`

export default function SaibaMais( { onClick, isCuradoria } ) {
  return (
    <SaibaMaisWrapper
      isCuradoria={ isCuradoria }
      onClick={ onClick }
    >
      <Info />

      <span>Saiba mais</span>
    </SaibaMaisWrapper>
  )
}

SaibaMais.propTypes = {
  'isCuradoria': bool.isRequired,
  'onClick': object.isRequired
}
